<template>
<div class="content-wrap">

	<div id="search">
		<div class="container">

			<div class="input-warp">
				<input type="text" :placeholder="l10.All_Educators_Body_Title1" v-on:keyup.enter="moveSearch()" v-model="searchWord" />
				<div id="searchIcon" @click="searchFaq()">
					<img src="@/assets/help/icon-faq-search.svg" />
				</div>
			</div>
		</div>
	</div>

	<AppContent @checkEmail="checkEmail()" @sendEmail="sendEmail()" @removeWord="removeWord" :searchWordList="searchWordList" :mode="mode" :listedContent="listedContent" :generalFaqs="generalFaqs" :schoolFaqs="schoolFaqs" :headTitle="headTitle"
	 :l10="l10" :contactUsForm="contactUsForm"></AppContent>

</div>
</template>
<script>
import AppContent from './AppViewContent'


export default {
	name: 'Help',
	components: {
		AppContent
	},
	props: ['subject', 'target'],
	beforeCreate() {
		document.getElementById("viewport").setAttribute("content", "width=" + 1024 + ", shrink-to-fit=no");
		var urlParams = new URLSearchParams(window.location.search);
		var lang = urlParams.get('lang');
		switch (lang) {
			case 'ko':
				this.$store.commit('setLanguage', 'ko');
				break;
			case 'en':
				this.$store.commit('setLanguage', 'en');
				break;
			case 'zh-cn':
			case 'cn':
				this.$store.commit('setLanguage', 'cn');
				break;
			default:

				break;
		}

	},
	mounted() {
		var vue = this;
		this.setFaqData();
	},

	data() {
		const text = require('../../text/help/laptop.js').default;
		const l10n = text[this.$store.state.lang] ? text[this.$store.state.lang] : text['en'];

		return {
			l10: l10n,
			searchWord: '',
			searchWordList: [],
			generalFaqs: {},
			schoolFaqs: {},
			frequencyQuestions: [],
			listedContent: [],
			mode: '',
			headTitle: '',
			subTitle: '',
			contactUsForm: {
				value: {
					email: '',
					subject: '',
					description: ''
				},
				error: {
					email: '',
					subject: false,
					description: false
				}
			},
			submenuCtrl: false,
			lang: this.$store.state.lang,
			env:this.$store.state.env



		}
	},
	methods: {
		getZendeskHelpCenterContent() {
			var axios = this.axios;
			var lang = this.$store.state.lang;
			var env = this.env;
			return new Promise(function(resolve, reject) {
				var zendesk = {};
				var params = {};
				lang = (lang == 'cn') ? 'zh-cn' : lang;
				params = (lang != 'en') ? {
					locale: lang
				} : {};

				axios.post(env.protocol+env.urlAPI+'/service/getZendeskHelpCenterContent', params, {
					headers: {
						'content-type': 'application/json; charset=UTF-8'
					}
				}).then(function(response) {
					var parseData = {
						'general': {},
						'school': {}
					};
					if (response.data.result) {
						switch (lang) {
							case 'en':
								var resData = JSON.parse(response.data.data);

								resData.section.sections.forEach(function(data) {
									if (data.category_id.toString() == '202556818') {
										parseData.school[data.id.toString()] = data;
										parseData.school[data.id.toString()].faqList = [];
									}

								});
								resData.article.articles.forEach(function(data) {
									if (parseData.school[data.section_id.toString()]) {
										parseData.school[data.section_id.toString()].faqList.push({
											title: data.name,
											body: data.body,
											id: data.id,
											sectionId: data.section_id
										});
									}

								})

							case 'ko':
							case 'cn':
							case 'zh-cn':
								var resData = JSON.parse(response.data.data);
								resData.section.sections.forEach(function(data) {
									if (data.category_id.toString() == '360001833854') {
										parseData.general[data.id.toString()] = data;
										parseData.general[data.id.toString()].faqList = [];
									}


								});
								resData.article.articles.forEach(function(data) {

									if (parseData.general[data.section_id.toString()]) {
										parseData.general[data.section_id.toString()].faqList.push({
											title: data.name,
											body: data.body,
											id: data.id,
											sectionId: data.section_id
										});
									}

								})

								break;

						}

						resolve(parseData);
					}
				});
			})

		},
		setFaqData() {
			var lang = this.$store.state.lang;
			return this.getZendeskHelpCenterContent().then((res) => {
				var general = {};
				var school = {};

				switch (lang) {
					case 'en':

						Object.keys(res.school).forEach(function(key) {
							school[key] = res.school[key];
						});
						this.schoolFaqs = school;


					case 'ko':
					case 'cn':
					case 'zh-cn':
						Object.keys(res.general).forEach(function(key) {
							general[key] = res.general[key];
						});

						this.generalFaqs = general;
						var frequency = [];
						var sectionTitle = this.generalFaqs['360004333194'].name;
						this.generalFaqs['360004333194'].faqList.forEach(function(value) {
							if (value.id == '360022343054') {
								frequency.push(value);
								value.sectionTitle = sectionTitle;
							}
							if (value.id == '360022343074') {
								frequency.push(value);
								value.sectionTitle = sectionTitle;
							}

						});

						sectionTitle = this.generalFaqs['360004382413'].name;
						this.generalFaqs['360004382413'].faqList.forEach(function(value) {
							if (value.id == '360022343434') {
								frequency.push(value);
								value.sectionTitle = sectionTitle;
							}
						});
						this.frequencyQuestions = frequency;
						this.generalFaqs = general;
						var mode = this.subject ? this.subject : '';

						this.changeContentList(mode);

						break;
				}




			})
		},

		setGerneralFaqTable(sectionId) {
			this.mode = "general";
			this.headTitle = this.generalFaqs[sectionId].name;
			this.listedContent = this.generalFaqs[sectionId].faqList;
		},
		setSchoolFaqTable() {
			this.headTitle = "Todo Math for school";
			this.mode = "school";
			var schoolFaqList = [];
			var list = this.schoolFaqs;
			Object.keys(this.schoolFaqs).forEach(function(key) {
				schoolFaqList = schoolFaqList.concat(list[key].faqList);
			});
			this.listedContent = schoolFaqList;
		},
		setFrequencyQuestions() {
			this.mode = "faqs";
			this.headTitle = this.l10.All_FAQ_tab1_Title1;
			this.listedContent = this.frequencyQuestions;
		},
		changeContentList() {
			var mode = this.subject ? this.subject : '';
			this.searchWord = '';

			switch (mode) {
				case 'general':

					this.setGerneralFaqTable(this.target);
					this.subTitle = this.generalFaqs[this.target].name;
					break;
				case 'faqs':
					this.subTitle = 'faqs';
					this.setFrequencyQuestions();
					break;
				case 'school':
					this.setSchoolFaqTable();
					this.subTitle = 'Todo Math for school';
					break;
				case 'contact':
					this.mode = 'contact';
					this.subTitle = this.l10.All_FAQ_tab2_Title1;
					break;
				case 'search':
					this.mode = 'search';
					this.searchWord = this.target ? this.target : '';

					this.searchFaq();
					break;
				default:
					this.setFrequencyQuestions();
					break;
			}
		},
		checkEmail() {
			var checkMailForm = /\S+@\S+\.\S+/;

			this.contactUsForm.error.email = "";
			if (!this.contactUsForm.value.email) {
				this.contactUsForm.error.email = "blank-error";
				return false;
			}
			if (!checkMailForm.test(this.contactUsForm.value.email)) {
				this.contactUsForm.error.email = "form-error";
				return false;
			}
			return true;
		},
		sendEmail() {
			var validationCheck = true;
			var formData = this.contactUsForm.value;
			var errorData = this.contactUsForm.error;
			Object.keys(formData).forEach(function(key) {
				errorData[key] = false;
				if (!formData[key]) {

					validationCheck = false;
					errorData[key] = "blank-error";
				}
			});
			validationCheck = !validationCheck ? validationCheck : this.checkEmail();
			if (!validationCheck) {
				return false;
			}
            var contactVal = this.contactUsForm;
			this.axios.post(this.env.protocol+this.env.urlAPI+'/service/sendMail', {
                from: this.contactUsForm.value.email,
                title: this.contactUsForm.value.subject,
                body: this.contactUsForm.value.description
			}, {
				headers: {
					'content-type': 'application/json; charset=UTF-8'
				}
			}).then(function(response) {
				if (response.data.result) {
					contactVal.value.email = '';
					contactVal.value.subject = '';
					contactVal.value.description = '';
					contactVal.error.email = '';
					contactVal.error.subject = false;
					contactVal.error.description = false;

				}
			});

		},
		moveSearch() {
			if (this.searchWord) {
				this.$router.push({
					name: 'HelpAppDetail',
					params: {
						subject: 'search',
						target: this.searchWord.replace(/(<([^>]+)>)/gi, "")
					}

				});
			}
		},
		removeWord(word) {
			var changedSearchWord = '';
			this.searchWordList.forEach(function(value) {
				if (word !== value) {
					changedSearchWord += value + ' ';
				}
			});
			if (changedSearchWord) {
				changedSearchWord = changedSearchWord.substr(0, changedSearchWord.length - 1).replace(/(<([^>]+)>)/gi, "");
				this.$router.push({
					name: 'HelpAppDetail',
					params: {
						subject: 'search',
						target: changedSearchWord
					}
				});
			} else {
				this.$router.push({
					name: 'HelpApp',
					params: {
						subject: 'search'
					}
				});
			}



		},
		searchFaq() {

			this.faqList = [];

			this.searchWordList = [];
			this.listedContent = [];
			this.mode = 'search';
			this.headTitle = "";
			var words = this.searchWord.split(' ');

			function checkWords(list) {
				var notBlankList = {};
				list.forEach(function(split) {
					if (split) {
						notBlankList[split] = true;
					}
				});
				return Object.keys(notBlankList);

			}
			words = checkWords(words);

			if (words.length <= 0) {
				return false;
			}



			var allfaq = [];
			var generalFaqs = this.generalFaqs;
			var schoolFaqs = this.schoolFaqs;
			var subjectNameList = {};

			function strip(html) {
				var tmp = document.createElement("DIV");
				tmp.innerHTML = html;
				return tmp.textContent || tmp.innerText || "";
			}
			Object.keys(generalFaqs).forEach(function(key) {
				var copy, bodyText;
				generalFaqs[key].faqList.forEach(function(faq) {
					copy = JSON.parse(JSON.stringify(faq));
					copy.bodyText = strip(copy.body);
					allfaq.push(copy);
				})

				subjectNameList[key] = generalFaqs[key].name;
			});
			Object.keys(schoolFaqs).forEach(function(key) {
				var copy, bodyText;
				schoolFaqs[key].faqList.forEach(function(faq) {
					copy = JSON.parse(JSON.stringify(faq));
					copy.bodyText = strip(copy.body);
					allfaq.push(copy);
				})
				subjectNameList[key] = schoolFaqs[key].name;
			});


			var searchedList = [];
			var koreanCheck = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

			if (words.length == 1) {

				var regex = new RegExp("\\b" + words[0] + "\\b", "gi");


				if (this.$store.state.lang == 'ko' && koreanCheck.test(words[0])) {
					regex = new RegExp("" + words[0] + "", "gi");
				}

				allfaq.forEach(function(faq) {

					var match = false;

					if (regex.test(faq.bodyText)) {
						match = true;
						if (!koreanCheck.test(words[0])) {
							faq.bodyText.match(regex).forEach(function(word) {
								// word=word.replace(/ /g,"");
								// var changeRegex = RegExp("\\b" + word + "\\b", "g");
								var changeRegex = RegExp("[\>]" + word + "\\b", "g");

								faq.body = faq.body.replace(changeRegex, '<span style="color:#42c0ff;font-weight:bold;"> ' + word + '</span>');

								// faq.body = faq.body.replace(/\>/g, '> ');

								changeRegex = RegExp("\\b[^\<]" + word + "\\b", "g");
								faq.body = faq.body.replace(changeRegex, '<span style="color:#42c0ff;font-weight:bold;"> ' + word + '</span>');


							});
						} else {
							faq.body = faq.body.replace(regex, '<span style="color:#42c0ff;font-weight:bold;"> ' + words[0] + '</span>');
						}

					}


					if (regex.test(faq.title)) {
						match = true;
						if (!koreanCheck.test(words[0])) {
							faq.title.match(regex).forEach(function(word) {
								word = word.replace(/ /g, "");
								var changeRegex = RegExp("\\b" + word + "\\b", "g");


								faq.title = faq.title.replace(changeRegex, '<span style="color:#42c0ff;font-weight:bold;">' + word + '</span>');

							});
						} else {
							faq.title = faq.title.replace(regex, '<span style="color:#42c0ff;font-weight:bold;"> ' + words[0] + '</span>');
						}

					}

					if (match) {
						faq.sectionTitle = subjectNameList[faq.sectionId];
						searchedList.push(faq);
					}


				})
			} else {
				var countGroupBySearchWord = {};
				for (var i = words.length; i > 0; i--) {
					countGroupBySearchWord[i + ''] = [];

				}
				var lang = this.$store.state.lang;
				allfaq.forEach(function(faq) {

					var matchCount = 0;
					words.forEach(function(word) {
						var regex = new RegExp("\\b" + word + "\\b", "gi");


						if (lang == 'ko' && koreanCheck.test(word)) {
							regex = new RegExp("" + word + "", "gi");
						}
						var isMatch = false;
						if (regex.test(faq.bodyText)) {
							isMatch = true;
							if (!koreanCheck.test(word)) {

								faq.bodyText.match(regex).forEach(function(detailWord) {

									var changeRegex = RegExp("[\>]" + detailWord + "\\b", "g");

									faq.body = faq.body.replace(changeRegex, '<span style="color:#42c0ff;font-weight:bold;"> ' + detailWord + '</span>');

									changeRegex = RegExp("[^\<|\s]" + detailWord + "\\b", "g");
									faq.body = faq.body.replace(changeRegex, '<span style="color:#42c0ff;font-weight:bold;"> ' + detailWord + '</span>');


								});
							} else {
								faq.body = faq.body.replace(regex, '<span style="color:#42c0ff;font-weight:bold;"> ' + word + '</span>');
							}

						}


						if (regex.test(faq.title)) {
							isMatch = true;
							if (!koreanCheck.test(word)) {
								faq.title.match(regex).forEach(function(detailWord) {

									var changeRegex = RegExp("" + detailWord + "", "g");
									faq.title = faq.title.replace(changeRegex, '<span style="color:#42c0ff;font-weight:bold;">' + detailWord + '</span>');

								});
							} else {
								faq.title = faq.title.replace(regex, '<span style="color:#42c0ff;font-weight:bold;"> ' + word + '</span>');
							}

						}

						matchCount = isMatch ? matchCount + 1 : matchCount;

					});

					if (matchCount > 0) {
						countGroupBySearchWord[matchCount + ''].push(faq);
						faq.sectionTitle = subjectNameList[faq.sectionId];

					};

				})

				for (var i = words.length; i > 0; i--) {
					if (countGroupBySearchWord[i + ''].length > 0)
						searchedList = searchedList.concat(countGroupBySearchWord[i + '']);

				}

			}
			this.listedContent = searchedList;
			this.searchWordList = words;



		}

	},
	watch: {
		$route(to, from) {

			this.changeContentList();
			this.submenuCtrl = false;

		},

	}
}
</script>
<style  scoped>
.content-wrap {
	position: relative;
	width: 100%;
}

#search {
	background-image: url('../../assets/help/img-faq-top-bg@2x.png');
	background-size: 1334px auto;
	background-position: center;
	height: 160px;

	font-size: 56px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.14;
	letter-spacing: -2px;
	text-align: center;
	color: #ffffff;

}

#search .input-warp {
	width: 600px;

	margin: 0 auto;

	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 160px;
}

#search .input-warp input {
	width: 600px;
	height: 60px;
	font-size: 18px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: -0.4px;
	padding: 18px 0;
	padding-left: 30px;
	padding-right: 80px;
	border-radius: 30px;
	border: solid 1px #e6e6e6;
	background-color: #ffffff;
	display: inline-block;
	position: relative;

}

#search .input-warp input:focus {
	outline: none;
}

#search #searchIcon {
	position: relative;
	right: 50px;
	top: -8px;

}


.header {
	background-image: url('../../assets/help/img-faq-top-bg-m.png');
	background-size: 1600px auto;
	background-position: center;
	height: 518px;

	font-size: 64px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.25;
	letter-spacing: -2.5px;
	text-align: center;
	color: #ffffff;

	position: relative;
	padding-top: 166px;


}

.menu-warp {
	height: 100px;
	width: 100%;
	top: 0;
	z-index: 50;
	position: absolute;
	text-align: left;
}

.submenu-warp {
	height: 100px;
	width: 100%;
	background-color: #fffcf7;
	border-bottom: solid 2px #e6e6e6;
}

.submenu-warp .cover {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background-color: #00000030;
	display: none;
	z-index: 5;
}


.search .input-warp {
	width: 600px;

	margin: 0 auto;
	margin-top: 20px;
	position: relative;
	display: flex;
}

.search .input-warp input {
	width: 600px;
	height: 60px;
	font-size: 18px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: -0.4px;
	padding: 18px 0;
	padding-left: 30px;
	padding-right: 80px;
	border-radius: 30px;
	border: solid 1px #e6e6e6;
	background-color: #ffffff;
	display: inline-block;

}

.search .input-warp input:focus {
	outline: none;
}

.search #searchIcon {
	position: absolute;
	right: 23px;
	top: -18px;

}

#helpMenu {
	display: none;
}

#helpMenuTitle {
	z-index: 10;
	width: 100%;
	height: 100%;

}

#helpMenuTitle>div {
	font-size: 28px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: -1px;
	color: #41403e;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100px;
	z-index: 10;
	position: relative;

	padding: 0 35px;
	background-color: #fffcf7;
	border-bottom: solid 2px #e6e6e6;


}

#helpMenuTitle>div::after {
	content: url('../../assets/curriculum/icon-down-arrow-m.svg');
	top: 8px;
	position: relative;
}

#helpMenu~ul {
	list-style-type: none;
	display: none;
	/* transition: all 0.5s linear; */
	transform: translateY(-100%);
	z-index: 8;
	margin: 0;
	padding: 0;
	position: absolute;
	background-color: #fffcf7;
	width: 100%;
	left: 0;
	padding: 60px 0;

	overflow-y: auto;
	font-size: 28px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: -0.6px;
	color: #41403e;

}

#helpMenu~ul li {
	width: 100%;
}

#helpMenu~ul li:first-of-type::after {
	content: '';
	width: 650px;
	height: 2px;
	background-color: #e6e6e6;
	display: block;
	position: relative;
	left: 50%;
	transform: translateX(-50%);
	margin-top: 36px;

}

#helpMenu~ul li:last-of-type::before {
	content: '';
	width: 650px;
	height: 2px;
	background-color: #e6e6e6;
	display: block;
	position: relative;
	left: 50%;
	transform: translateX(-50%);
	margin-bottom: 36px;

}

#helpMenu~ul li a {
	width: 720px;
	padding: 0 35px;
	margin: 0 auto;

	display: flex;
	align-items: center;

}

#helpMenu~ul li~li {
	margin-top: 36px;
}

#helpMenu~ul li a span {
	display: flex;
	align-items: center;
	width: 720px;
	margin: 0 auto;
	padding: 0 35px;
}

#helpMenu~ul li ul {
	padding-left: 28px;
	list-style-type: none;
}

#helpMenu:checked~#helpMenuTitle>div::after {
	transform: rotate(180deg);
	top: 3px;
}

#helpMenu:checked~.cover {
	display: block;
}

#helpMenu:checked~ul {
	transform: translateY(0px);
	display: block;
}

.mobile-container {
	margin: 0 auto;
	height: auto;
	min-height: 100px;
	width: 720px;
	padding: 0 35px;
}
</style>



// WEBPACK FOOTER //
// src/pages/help/AppView.vue